/**
 * MaintenanceCountdown Component - Live countdown display
 *
 * Features:
 * - Real-time countdown to maintenance time
 * - Updates every second
 * - Handles past times gracefully
 */

import React, { useState, useEffect } from 'react';
import './MaintenanceCountdown.css';

function MaintenanceCountdown({ targetTime }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetTime));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetTime));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetTime]);

  // Target time not provided
  if (!targetTime) {
    return null;
  }

  // Time has passed
  if (timeLeft.isPast) {
    return (
      <div className="maintenance-countdown maintenance-countdown--past">
        <span className="maintenance-countdown__label">Maintenance</span>
        <span className="maintenance-countdown__status">Starting now</span>
      </div>
    );
  }

  return (
    <div className="maintenance-countdown">
      <span className="maintenance-countdown__label">Maintenance begins in</span>
      <div className="maintenance-countdown__timer">
        {timeLeft.days > 0 && (
          <TimeUnit value={timeLeft.days} label="days" />
        )}
        <TimeUnit value={timeLeft.hours} label="hrs" />
        <TimeUnit value={timeLeft.minutes} label="min" />
        <TimeUnit value={timeLeft.seconds} label="sec" />
      </div>
    </div>
  );
}

function TimeUnit({ value, label }) {
  return (
    <div className="time-unit">
      <span className="time-unit__value">{String(value).padStart(2, '0')}</span>
      <span className="time-unit__label">{label}</span>
    </div>
  );
}

function calculateTimeLeft(targetTime) {
  const target = new Date(targetTime);
  const now = new Date();
  const diff = target - now;

  if (diff <= 0) {
    return { isPast: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return { isPast: false, days, hours, minutes, seconds };
}

export default MaintenanceCountdown;
